<template>
  <div class="fucai3d-container">
    <h1>{{ currentGameLabel }} 所有可能的号码组合</h1>

    <!-- 彩种选择 -->
    <div class="game-select">
      <label>选择彩种：</label>
      <el-select v-model="currentGame" placeholder="请选择彩种" style="width: 200px">
        <el-option v-for="item in gameOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
    </div>

    <!-- 筛选条件 -->
    <div class="filters">
      <!-- 基础条件：分为两列 -->
      <el-row :gutter="20">
        <!-- 左侧：跨度剔除 -->
        <el-col :span="12">
          <div class="filter-group">
            <label>总跨度剔除:</label>
            <el-checkbox-group v-model="filters.totalSpan">
              <el-checkbox v-for="n in 10" :key="'ts'+n" :label="n-1">{{ n-1 }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="filter-group">
            <label>百十跨度剔除:</label>
            <el-checkbox-group v-model="filters.hundredTenSpan">
              <el-checkbox v-for="n in 10" :key="'ht'+n" :label="n-1">{{ n-1 }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="filter-group">
            <label>十个跨度剔除:</label>
            <el-checkbox-group v-model="filters.tenOneSpan">
              <el-checkbox v-for="n in 10" :key="'to'+n" :label="n-1">{{ n-1 }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="filter-group">
            <label>百个跨度剔除:</label>
            <el-checkbox-group v-model="filters.hundredOneSpan">
              <el-checkbox v-for="n in 10" :key="'ho'+n" :label="n-1">{{ n-1 }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-col>

        <!-- 右侧：按位剔除 -->
        <el-col :span="12">
          <div class="filter-group">
            <label>百位剔除:</label>
            <el-checkbox-group v-model="filters.excludeHundred">
              <el-checkbox v-for="n in 10" :key="'h'+n" :label="n-1">{{ n-1 }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="filter-group">
            <label>十位剔除:</label>
            <el-checkbox-group v-model="filters.excludeTen">
              <el-checkbox v-for="n in 10" :key="'t'+n" :label="n-1">{{ n-1 }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="filter-group">
            <label>个位剔除:</label>
            <el-checkbox-group v-model="filters.excludeOne">
              <el-checkbox v-for="n in 10" :key="'o'+n" :label="n-1">{{ n-1 }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-col>
      </el-row>

      <!-- 扩展条件折叠开关 -->
      <div class="expand-btn" @click="toggleExpand">
        <span>{{ showMore ? '收起扩展条件 ▲' : '展开扩展条件 ▼' }}</span>
      </div>

      <!-- 扩展条件 -->
      <el-collapse-transition>
        <div v-show="showMore" class="extra-filters">
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="filter-group">
                <label>和值剔除:</label>
                <el-checkbox-group v-model="filters.excludeSum">
                  <el-checkbox v-for="n in 28" :key="'s'+n" :label="n-1">{{ n-1 }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="filter-group">
                <label>大小组合剔除:</label>
                <el-checkbox-group v-model="filters.excludeBigSmall">
                  <el-checkbox v-for="combo in bigSmallOptions" :key="combo" :label="combo">{{ combo }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <div class="filter-group">
                <label>奇偶组合剔除:</label>
                <el-checkbox-group v-model="filters.excludeOddEven">
                  <el-checkbox v-for="combo in oddEvenOptions" :key="combo" :label="combo">{{ combo }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="filter-group">
                <label>质合组合剔除:</label>
                <el-checkbox-group v-model="filters.excludePrimeComposite">
                  <el-checkbox v-for="combo in primeCompositeOptions" :key="combo" :label="combo">{{ combo }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-collapse-transition>

      <!-- 筛选操作按钮 -->
      <div class="filter-actions">
        <el-button type="danger" @click="applyFilters">筛选号码</el-button>
        <el-button type="danger" plain @click="resetFilters">重置</el-button>
      </div>
    </div>

    <el-divider></el-divider>

    <!-- 数量统计与操作 -->
    <div class="count">
      <el-button
        type="primary"
        plain
        @click="restoreNumbers"
        :disabled="removedNumbers.length === 0"
      >
        还原删除({{ removedNumbers.length }})
      </el-button>
      <el-tag type="info">总组合数: {{ allNumbers.length }}</el-tag>
      <el-tag type="success">已筛选: {{ filteredNumbers.length }}</el-tag>
      <el-tag type="warning">点击将移除该条数据</el-tag>
    </div>

    <!-- 号码展示 -->
    <div class="numbers">
      <el-tag
        v-for="num in filteredNumbers"
        :key="num"
        class="num-tag"
        @click="removeNumber(num)"
      >{{ num }}</el-tag>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RemoveNum',
  data() {
    return {
      showMore: false,
      allNumbers: [],
      currentNumbers: [],
      removedNumbers: [],
      currentGame: 'fucai3d',
      gameOptions: [
        { label: '福彩3D', value: 'fucai3d' },
        { label: '排列三', value: 'pailie3' }
      ],
      filters: {
        totalSpan: [],
        hundredTenSpan: [],
        tenOneSpan: [],
        hundredOneSpan: [],
        excludeHundred: [],
        excludeTen: [],
        excludeOne: [],
        excludeSum: [],
        excludeBigSmall: [],
        excludeOddEven: [],
        excludePrimeComposite: []
      },
      bigSmallOptions: ['大大大','大大小','大小大','小大大','大小小','小大小','小小大','小小小'],
      oddEvenOptions: ['奇奇奇','奇奇偶','奇偶奇','偶奇奇','偶偶奇','偶奇偶','奇偶偶','偶偶偶'],
      primeCompositeOptions: ['质质质','质质合','质合质','合质质','合合质','合质合','质合合','合合合']
    }
  },
  created() {
    this.generateCombinations()
    this.currentNumbers = [...this.allNumbers]
  },
  computed: {
    filteredNumbers() {
      return this.currentNumbers
    },
    currentGameLabel() {
      const option = this.gameOptions.find(g => g.value === this.currentGame)
      return option ? option.label : ''
    }
  },
  watch: {
    currentGame() {
      this.resetFilters()
      this.generateCombinations()
      this.currentNumbers = [...this.allNumbers]
    }
  },
  methods: {
    toggleExpand() {
      this.showMore = !this.showMore
    },
    generateCombinations() {
      const combinations = []
      for (let i = 0; i <= 999; i++) {
        combinations.push(i.toString().padStart(3, '0'))
      }
      this.allNumbers = combinations
    },
    getBigSmall(h, t, o) {
      const bs = n => (n >= 5 ? '大' : '小')
      return bs(h) + bs(t) + bs(o)
    },
    getOddEven(h, t, o) {
      const oe = n => (n % 2 === 0 ? '偶' : '奇')
      return oe(h) + oe(t) + oe(o)
    },
    getPrimeComposite(h, t, o) {
      const primes = [2, 3, 5, 7]
      const pc = n => (primes.includes(n) ? '质' : '合')
      return pc(h) + pc(t) + pc(o)
    },
    applyFilters() {
      this.currentNumbers = this.allNumbers.filter(num => {
        const [h, t, o] = num.split('').map(Number)
        const spanTotal = Math.max(h, t, o) - Math.min(h, t, o)
        const spanHT = Math.abs(h - t)
        const spanTO = Math.abs(t - o)
        const spanHO = Math.abs(h - o)
        const sum = h + t + o
        const bsCombo = this.getBigSmall(h, t, o)
        const oeCombo = this.getOddEven(h, t, o)
        const pcCombo = this.getPrimeComposite(h, t, o)

        if (this.filters.totalSpan.includes(spanTotal)) return false
        if (this.filters.hundredTenSpan.includes(spanHT)) return false
        if (this.filters.tenOneSpan.includes(spanTO)) return false
        if (this.filters.hundredOneSpan.includes(spanHO)) return false
        if (this.filters.excludeHundred.includes(h)) return false
        if (this.filters.excludeTen.includes(t)) return false
        if (this.filters.excludeOne.includes(o)) return false
        if (this.filters.excludeSum.includes(sum)) return false
        if (this.filters.excludeBigSmall.includes(bsCombo)) return false
        if (this.filters.excludeOddEven.includes(oeCombo)) return false
        if (this.filters.excludePrimeComposite.includes(pcCombo)) return false

        return true
      })
      this.$message.success(`筛选完成，剩余 ${this.currentNumbers.length} 个号码`)
    },
    resetFilters() {
      this.filters = {
        totalSpan: [],
        hundredTenSpan: [],
        tenOneSpan: [],
        hundredOneSpan: [],
        excludeHundred: [],
        excludeTen: [],
        excludeOne: [],
        excludeSum: [],
        excludeBigSmall: [],
        excludeOddEven: [],
        excludePrimeComposite: []
      }
      this.currentNumbers = [...this.allNumbers]
      this.removedNumbers = []
      this.$message.info('已重置所有筛选条件')
    },
    removeNumber(num) {
      const index = this.currentNumbers.indexOf(num)
      if (index > -1) {
        this.currentNumbers.splice(index, 1)
        this.removedNumbers.push(num)
        this.$message.success(`已移除号码 ${num}`)
      }
    },
    restoreNumbers() {
      if (this.removedNumbers.length > 0) {
        const numToRestore = this.removedNumbers.pop()
        this.currentNumbers.push(numToRestore)
        this.currentNumbers.sort()
        this.$message.success(`已还原号码 ${numToRestore}`)
      }
    }
  }
}
</script>

<style scoped>
.fucai3d-container {
  max-width: 1200px;
  margin: 20px auto;
  font-family: Arial, sans-serif;
  text-align: center;
}
.fucai3d-container h1 {
  color: #f44336;
}
.game-select {
  margin: 20px 0;
}
.numbers {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 20px;
}
.num-tag {
  margin: 4px;
  cursor: pointer;
}
.count {
  margin: 20px 0;
}
.filter-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 15px;
}
.filter-group label {
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 14px;
}
.filter-actions {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin: 20px 0;
}
.el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
}
.el-checkbox {
  margin-right: 10px;
  margin-bottom: 5px;
}
.expand-btn {
  text-align: center;
  margin: 15px 0;
  color: #409eff;
  cursor: pointer;
  font-weight: bold;
}
.extra-filters {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/usingTools/removeNum.vue